import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Clipboard } from 'ts-clipboard';
import { CapAlertService } from './cap-alert.service';
import { BaselogService, LogMailRequest } from '../../base-api';
import { Subscription } from 'rxjs';
import { CapAlert } from './cap-alert.interface';
import { CapAlertType } from './cap-alert.enum';
import { CapAlertLevel } from './cap-alert-level.enum';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CapAlertComponent } from './cap-alert.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cap-alert-list',
  styleUrls: ['./cap-alert-list.component.scss'],
  templateUrl: './cap-alert-list.component.html',
  imports: [CapAlertComponent]
})
export class CapAlertListComponent implements OnInit, OnDestroy {

  @Input()
  public alertLevel: CapAlertLevel = CapAlertLevel.GLOBAL;
  public alerts: CapAlert[] = [];
  public capAlertTypeDanger = CapAlertType.DANGER;

  private subscription = new Subscription();

  constructor(private capAlertService: CapAlertService, private loggingService: BaselogService, private router: Router,
              protected translate: TranslateService) {
  }

  ngOnInit(): void {
    this.subscription.add(this.capAlertService.alerts$
      .pipe(map(alerts => alerts.filter(alert => alert.alertLevel === this.alertLevel)))
      .subscribe(alerts => this.alerts = alerts));
    this.capAlertService.nextPage();
  }

  public copyStackToClipboard(alert: CapAlert) {
    if (alert && alert.stack) {
      let stack = '';
      stack = alert.stack.concat('\n' + 'Date: ' + new Date().toString() + '\n' + 'URL: ' + this.router.url);
      Clipboard.copy(stack);
    }
  }

  public reportError(alert: CapAlert) {
    if (alert && alert.stack) {
      const request: LogMailRequest = { message: alert.stack.toString() };
      request.message = request.message.concat('\n' + 'Date: ' + new Date().toString() + '\n' + 'URL: ' + this.router.url);
      this.subscription.add(this.loggingService.report(request).subscribe());
    }
  }

  public dismiss(alert: CapAlert) {
    this.capAlertService.dismiss(alert);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
